import Vue from 'vue';
import ElementUI from 'element-ui';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import dayjs from 'dayjs';
import directives from '@/directives';
import 'dayjs/locale/zh-cn';
import { getExtensionToIcon } from '@/utils/utils';

ElementUI.Table.props.size = {
  type: String,
  default: 'medium'
};

dayjs.locale('zh-cn');

Vue.prototype.getIconClass = function getIconClass(extension, item) {
  return getExtensionToIcon(extension, item);
};

Vue.use(ElementUI, { size: 'small' });
Vue.use(directives);

Vue.component('ElImageViewer', ElImageViewer);
